import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,_vm._b({attrs:{"label":_vm.label,"items":_vm.grupos,"item-value":"id","item-text":"descricao","outlined":_vm.outlined,"clearable":"","small-chips":""},model:{value:(_vm.VALOR_SELECIONADO),callback:function ($$v) {_vm.VALOR_SELECIONADO=$$v},expression:"VALOR_SELECIONADO"}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }